/* RASO — DA v9 (brouillon) : aperçu rapide, galerie par couleur, vitrine flags, zoom, compte à rebours */
document.addEventListener('DOMContentLoaded', () => {
  const root = document.documentElement;
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  /* ---------- Fiche produit : la galerie suit la couleur choisie ---------- */
  const gallery = document.querySelector('.main-product:not(.main-product--configurator) .product-gallery');
  const mainSelect = document.querySelector('.main-product .product-form [data-variant-select]');
  if (gallery && mainSelect && gallery.querySelector('.product-media')) {
    const productUrl = location.pathname.replace(/\/$/, '');
    let variantsMedia = null;
    const loadVariants = async () => {
      if (variantsMedia) return variantsMedia;
      try {
        const data = await (await fetch(productUrl + '.js', { headers: { Accept: 'application/json' } })).json();
        variantsMedia = {};
        (data.variants || []).forEach((v) => { if (v.featured_media) variantsMedia[String(v.id)] = String(v.featured_media.id); });
      } catch (e) { variantsMedia = {}; }
      return variantsMedia;
    };
    const showMedia = (mediaId) => {
      const target = mediaId && gallery.querySelector('.product-media[data-media-id="' + mediaId + '"]');
      if (!target) return;
      const isCarousel = getComputedStyle(gallery).display === 'flex';
      if (isCarousel) {
        gallery.scrollTo({ left: target.offsetLeft - gallery.offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
      } else {
        if (gallery.firstElementChild !== target) gallery.prepend(target);
        const top = gallery.getBoundingClientRect().top;
        if (top < 0) window.scrollTo({ top: window.scrollY + top - 90, behavior: reduce ? 'auto' : 'smooth' });
      }
      target.classList.remove('is-spotlight'); void target.offsetWidth; target.classList.add('is-spotlight');
    };
    mainSelect.addEventListener('change', async () => {
      const map = await loadVariants();
      showMedia(map[mainSelect.value]);
    });
  }

  /* ---------- Zoom : clic pour agrandir, l'image suit la souris ---------- */
  document.addEventListener('click', (event) => {
    const img = event.target.closest('.r-product-zoom img');
    if (!img) return;
    const rect = img.getBoundingClientRect();
    img.style.transformOrigin = ((event.clientX - rect.left) / rect.width * 100) + '% ' + ((event.clientY - rect.top) / rect.height * 100) + '%';
    img.classList.toggle('is-zoomed');
  });
  document.addEventListener('mousemove', (event) => {
    const img = document.querySelector('.r-product-zoom.is-open img.is-zoomed');
    if (!img) return;
    const box = img.parentElement.getBoundingClientRect();
    img.style.transformOrigin = ((event.clientX - box.left) / box.width * 100) + '% ' + ((event.clientY - box.top) / box.height * 100) + '%';
  });
  /* à chaque ouverture du zoom, on repart de l'image entière */
  document.addEventListener('click', (event) => {
    if (event.target.closest('.product-gallery .product-media > img')) document.querySelector('.r-product-zoom img')?.classList.remove('is-zoomed');
  }, true);

  /* ---------- Aperçu rapide depuis les collections ---------- */
  const cards = document.querySelectorAll('.product-card');
  if (cards.length && finePointer && window.innerWidth > 900 && !document.querySelector('.main-product')) {
    let modal = null, lastFocus = null;
    const buildModal = () => {
      modal = document.createElement('div');
      modal.className = 'qv-modal';
      modal.innerHTML = '<div class="qv-modal__overlay" data-qv-close></div><div class="qv-modal__box" role="dialog" aria-modal="true" aria-labelledby="QuickViewTitle" tabindex="-1"><button class="qv-modal__close" type="button" data-qv-close aria-label="Fermer l’aperçu">×</button><div class="qv-modal__body"></div></div>';
      document.body.appendChild(modal);
      modal.addEventListener('click', (e) => { if (e.target.closest('[data-qv-close]')) closeModal(); });
      modal.addEventListener('change', (e) => {
        const select = e.target.closest('.qv [data-variant-select]');
        if (!select) return;
        const media = select.selectedOptions[0]?.dataset.media;
        const fig = media && modal.querySelector('.qv__media [data-media-id="' + media + '"]');
        if (fig) fig.parentElement.scrollTo({ left: fig.offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
      });
      /* le tiroir panier s'ouvre après un ajout : on ferme l'aperçu */
      const drawer = document.querySelector('[data-cart-drawer]');
      if (drawer) new MutationObserver(() => { if (drawer.classList.contains('is-open')) closeModal(true); }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    };
    const addDots = () => {
      const media = modal.querySelector('.qv__media');
      const figures = media ? media.querySelectorAll('figure') : [];
      if (figures.length < 2) return;
      const dots = document.createElement('div');
      dots.className = 'qv__dots';
      figures.forEach((_, i) => { const s = document.createElement('span'); if (!i) s.className = 'is-active'; dots.appendChild(s); });
      modal.querySelector('.qv').appendChild(dots);
      media.addEventListener('scroll', () => {
        const i = Math.round(media.scrollLeft / media.clientWidth);
        dots.querySelectorAll('span').forEach((s, k) => s.classList.toggle('is-active', k === i));
      }, { passive: true });
    };
    const openModal = async (url) => {
      if (!modal) buildModal();
      lastFocus = document.activeElement;
      const body = modal.querySelector('.qv-modal__body');
      body.innerHTML = '<div class="qv-modal__loading">Chargement…</div>';
      modal.classList.add('is-open');
      root.classList.add('qv-open');
      modal.querySelector('.qv-modal__box').focus({ preventScroll: true });
      try {
        const clean = url.split('#')[0];
        const response = await fetch(clean + (clean.includes('?') ? '&' : '?') + 'section_id=quick-view');
        if (!response.ok) throw new Error();
        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const qv = doc.querySelector('[data-qv]');
        if (!qv) throw new Error();
        body.replaceChildren(qv);
        addDots();
      } catch (e) {
        window.location.href = url;
      }
    };
    const closeModal = (keepFocus) => {
      if (!modal) return;
      modal.classList.remove('is-open');
      root.classList.remove('qv-open');
      if (!keepFocus) lastFocus?.focus?.({ preventScroll: true });
    };
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && modal?.classList.contains('is-open')) closeModal(); });

    cards.forEach((card) => {
      const link = card.querySelector('.product-card__media-link');
      const media = card.querySelector('.product-card__media');
      if (!link || !media || card.querySelector('.qv-trigger')) return;
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'qv-trigger';
      button.textContent = 'Aperçu rapide';
      button.setAttribute('aria-label', 'Aperçu rapide : ' + (link.getAttribute('aria-label') || ''));
      card.appendChild(button);
      const place = () => { card.style.setProperty('--qv-top', (media.offsetTop) + 'px'); };
      place();
      button.addEventListener('click', (e) => { e.preventDefault(); openModal(link.href); });
    });
  }

  /* ---------- Vitrine Flag Series : inclinaison 3D qui suit la souris ---------- */
  if (finePointer && !reduce) {
    document.querySelectorAll('.flags-world__card').forEach((card) => {
      let frame = 0;
      card.addEventListener('pointermove', (e) => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => {
          const r = card.getBoundingClientRect();
          const x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
          card.classList.add('is-tilting');
          card.style.setProperty('--ry', ((x - 0.5) * 10).toFixed(2) + 'deg');
          card.style.setProperty('--rx', ((0.5 - y) * 10).toFixed(2) + 'deg');
          card.style.setProperty('--mx', (x * 100).toFixed(1) + '%');
          card.style.setProperty('--my', (y * 100).toFixed(1) + '%');
        });
      });
      card.addEventListener('pointerleave', () => {
        cancelAnimationFrame(frame);
        card.classList.remove('is-tilting');
        card.style.setProperty('--rx', '0deg');
        card.style.setProperty('--ry', '0deg');
      });
    });
  }

  /* ---------- Compte à rebours des boutiques clubs ---------- */
  const pad = (n) => String(n).padStart(2, '0');
  document.querySelectorAll('[data-countdown]').forEach((box) => {
    const end = Number(box.dataset.countdown) * 1000;
    if (!end) return;
    const cells = { d: box.querySelector('[data-cd="d"]'), h: box.querySelector('[data-cd="h"]'), m: box.querySelector('[data-cd="m"]'), s: box.querySelector('[data-cd="s"]') };
    const tick = () => {
      const left = end - Date.now();
      if (left <= 0) {
        box.classList.add('is-closed');
        box.querySelector('.club-countdown__timer')?.setAttribute('hidden', '');
        box.querySelector('.club-countdown__date')?.setAttribute('hidden', '');
        box.querySelector('.club-countdown__label')?.setAttribute('hidden', '');
        box.querySelector('.club-countdown__closed')?.removeAttribute('hidden');
        return false;
      }
      const t = Math.floor(left / 1000);
      cells.d.textContent = pad(Math.floor(t / 86400));
      cells.h.textContent = pad(Math.floor(t % 86400 / 3600));
      cells.m.textContent = pad(Math.floor(t % 3600 / 60));
      cells.s.textContent = pad(t % 60);
      box.classList.toggle('is-urgent', left < 48 * 3600 * 1000);
      return true;
    };
    if (tick()) { const timer = setInterval(() => { if (!tick()) clearInterval(timer); }, 1000); }
  });
  /* badge « Commandes ouvertes » du bandeau clubs : seulement si la date n'est pas passée */
  document.querySelectorAll('[data-open-until]').forEach((badge) => {
    if (Number(badge.dataset.openUntil) * 1000 > Date.now()) badge.hidden = false;
  });
});
